export default
{
    methods:
    {
        formatNumber: ( value ) =>
        {
            if( value < 10 )
            {
                return '0'+value.toString();
            }

            return value.toString();
        },

        getHour()
        {
            if( this.hour24 )
            {
                return this.hour;
            }
            else
            {
                if( this.hour === 12 )
                {
                    return this.ampm === 'AM' ? 0 : 12;
                }
                else
                {
                    return this.hour + ( this.ampm === 'PM' ? 12 : 0 );
                }
            }
        },

        onChange()
        {
            this.$emit('update', { hours: this.getHour(), minutes: this.minute, seconds: this.second });
        }
    }
}